export default __webpack_public_path__ + "static/media/resultados_updated.fa9f5d4c.png";